import { normalizeReviewState } from 'src/addon/reviewStateMemory';
import { CHEMKIT_REVIEW_EXTENSION_VERSION } from '@chemkit/contracts/integration/reviewProtocol';

const warnedReviewEventPayloads = new Set();

function toPositiveInt(value) {
  const numeric = Number.parseInt(String(value), 10);
  if (!Number.isFinite(numeric) || numeric <= 0) {
    return null;
  }
  return numeric;
}

function isReviewLockedState(state) {
  return state === 'review_pending' || state === 'signed_off';
}

function warnBadReviewPayloadOnce(key, payload) {
  if (warnedReviewEventPayloads.has(key)) {
    return;
  }
  warnedReviewEventPayloads.add(key);
  // eslint-disable-next-line no-console
  console.warn('[chemkit] Invalid review-state event payload', payload);
}

export function parseReviewStateChangedPayload(payload) {
  if (!payload || typeof payload !== 'object') {
    warnBadReviewPayloadOnce('missing-detail', payload);
    return null;
  }

  const reactionId = toPositiveInt(payload.reactionId);
  const state = normalizeReviewState(payload.state);
  const { isLocked, version } = payload;
  const expectedLock = isReviewLockedState(state);
  if (!reactionId || !state || typeof isLocked !== 'boolean' || version !== CHEMKIT_REVIEW_EXTENSION_VERSION || isLocked !== expectedLock) {
    const key = `${String(payload.reactionId)}:${String(payload.state)}:${String(payload.isLocked)}:${String(payload.version)}`;
    warnBadReviewPayloadOnce(key, payload);
    return null;
  }

  return {
    reactionId,
    state,
    isLocked,
  };
}
